// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__Ho563","empty":"ModalGraph_empty__j1u0n"};